// Contact.tsx - With reCAPTCHA v3 Provider
import React, { useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import Header from "./Header";
import Footer from "./Footer";
import ContactForm from "./ContactForm";
import { Phone, Mail, MapPin, Clock } from "lucide-react";

const Contact: React.FC = () => {
  useEffect(() => {
    document.title = "Contact Us - BidBro | Get Help with Home Improvement Projects";
  }, []);

  const handleSubmitSuccess = () => {
    // Optional: Add analytics tracking or additional success actions
    console.log("Contact form submitted successfully");
  };

  const handleSubmitError = (error: string) => {
    // Optional: Add error tracking
    console.error("Contact form submission error:", error);
  };

  // Get reCAPTCHA site key from environment
  const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_V3_SITE_KEY;

  if (!RECAPTCHA_SITE_KEY) {
    console.error('reCAPTCHA v3 site key not found in environment variables');
  }

  return (
    <div className="min-h-screen bg-white">
      <Header isFullWidth={true} />

      {/* Hero Section */}
      <section className="py-5 bg-light" style={{ marginTop: "80px" }}>
        <Container>
          <div className="text-center mb-5">
            <h1 className="display-4 fw-bold mb-3">Get in Touch</h1>
            <p className="fs-5 text-muted mb-0">
              We're here to help with your home improvement projects
            </p>
          </div>
        </Container>
      </section>

      {/* Main Content */}
      <section className="py-5">
        <Container>
          <Row className="justify-content-center">
            {/* Contact Form - Centered */}
            <Col lg="12" xl="12">
              {RECAPTCHA_SITE_KEY ? (
                <GoogleReCaptchaProvider
                  reCaptchaKey={RECAPTCHA_SITE_KEY}
                  language="en"
                  useRecaptchaNet={false}
                  useEnterprise={false}
                  scriptProps={{
                    async: false,
                    defer: false,
                    appendTo: "head",
                    nonce: undefined,
                  }}
                >
                  <ContactForm 
                    onSubmitSuccess={handleSubmitSuccess}
                    onSubmitError={handleSubmitError}
                  />
                </GoogleReCaptchaProvider>
              ) : (
                <div className="alert alert-warning">
                  <h4>Configuration Required</h4>
                  <p>reCAPTCHA v3 site key not configured. Please add <code>REACT_APP_RECAPTCHA_V3_SITE_KEY</code> to your environment variables.</p>
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </section>
      <Footer />
    </div>
  );
};

export default Contact;